<!-- Page Header with Actions -->
<app-page-header
  title="Kundendetails"
  [subtitle]="(gatewayCustomer$ | async)?.customerNo ? 'Kundennr. ' + (gatewayCustomer$ | async)?.customerNo : ''"
  icon="person"
  [showBackButton]="true"
  [actions]="headerActions"
  variant="gradient">
</app-page-header>

<!-- Apple-style Content Grid -->
<div class="apple-slide-up">
  <div class="apple-customer-details-grid">
    <!-- Info and Status Section -->
    <div class="info-status-section">
      <!-- Info Card -->
      <div class="apple-card info-card">
        <div class="apple-card-header">
          <div class="apple-card-icon info-icon">
            <mat-icon>info</mat-icon>
          </div>
          <div class="apple-card-title-section">
            <h3>Kundeninformationen</h3>
          </div>
        </div>

        <div class="apple-card-content" *ngIf="gatewayCustomer$ | async as gatewayCustomer">
          <div class="apple-info-row">
            <span class="apple-info-label">
              <mat-icon class="row-icon">business</mat-icon>
              Firma (Kurz)
            </span>
            <span class="apple-info-value">{{ gatewayCustomer.companyShortName }}</span>
          </div>
          <div class="apple-info-row">
            <span class="apple-info-label">
              <mat-icon class="row-icon">apartment</mat-icon>
              Firma (Name)
            </span>
            <span class="apple-info-value">{{ gatewayCustomer.companyName }}</span>
          </div>
          <div class="apple-info-row">
            <span class="apple-info-label">
              <mat-icon class="row-icon">mail</mat-icon>
              E-Mail
            </span>
            <span class="apple-info-value">{{ gatewayCustomer.mail }}</span>
          </div>
        </div>
      </div>

      <!-- Registration Status Card -->
      <div class="apple-card status-card" *ngIf="customer$ | async as customer">
        <div class="apple-card-header">
          <div class="apple-card-icon status-icon">
            <mat-icon>account_circle</mat-icon>
          </div>
          <div class="apple-card-title-section">
            <h3>Registrierungsstatus</h3>
          </div>
        </div>

        <div class="apple-card-content">
          <div class="status-chip-wrapper">
            <mat-chip [color]="getStatusColor(customer.registrationStatus || '')">
              <mat-icon>{{ customer.registrationStatus === 'Pending' ? 'schedule' : customer.registrationStatus ===
                'Unlocked' ? 'check_circle' : 'cancel' }}</mat-icon>
              {{ getStatusLabel(customer.registrationStatus || '') }}
            </mat-chip>
          </div>

          <div class="status-actions" *ngIf="customer.registrationStatus === 'Pending'">
            <button class="apple-button apple-button-primary" (click)="approveCustomer(customer.id)">
              <mat-icon class="">check_circle</mat-icon>
              Freischalten
            </button>
            <button class="apple-button apple-button-error" (click)="rejectCustomer(customer.id)">
              <mat-icon>cancel</mat-icon>
              Ablehnen
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Coins and Actions Section -->
    <div class="coins-actions-section">
      <!-- Coins Card -->
      <div class="apple-card coins-card" *ngIf="customer$ | async as customer">
        <div class="apple-card-header">
          <div class="apple-card-icon coins-icon">
            <mat-icon>monetization_on</mat-icon>
          </div>
          <div class="apple-card-title-section">
            <h3>Coin-Guthaben</h3>
          </div>
        </div>

        <div class="apple-card-content">
          <div class="coin-balance-item">
            <div class="balance-icon-wrapper total">
              <mat-icon class="balance-icon">account_balance_wallet</mat-icon>
            </div>
            <div class="balance-info">
              <span class="balance-label">Gesamt</span>
              <span class="balance-value">{{ customer.coinsTotal }}</span>
            </div>
          </div>

          <div class="coin-balance-item">
            <div class="balance-icon-wrapper current">
              <mat-icon class="balance-icon">stars</mat-icon>
            </div>
            <div class="balance-info">
              <span class="balance-label">Verfügbar</span>
              <span class="balance-value">{{ customer.coinsCurrent }}</span>
            </div>
          </div>
        </div>

        <div class="apple-card-actions">
          <button class="apple-button apple-button-primary apple-button-large"
            [routerLink]="['/admin/customers/transactions',customer.reflexCustomerNo]">
            <mat-icon>arrow_forward</mat-icon>
            Transaktionen ansehen
          </button>

          <button class="apple-button apple-button-primary apple-button-large"
            (click)="openAddCoinsDialog(customer?.reflexCustomerNo)">
            <mat-icon>add_circle</mat-icon>
            Coins hinzufügen
          </button>
        </div>
      </div>
    </div>

    <!-- Orders Table (Full Width) -->
    <div class="orders-section">
      <div class="apple-card orders-card full-width">
        <div class="apple-card-header">
          <div class="apple-card-icon orders-icon">
            <mat-icon>shopping_cart</mat-icon>
          </div>
          <div class="apple-card-title-section">
            <h3>Aufträge</h3>
          </div>
        </div>

        <div class="apple-card-content">
          <div class="orders-table-wrapper">
            <table class="apple-table">
          <thead>
            <tr>
              <th class="apple-table-header">Auftragsnr.</th>
              <th class="apple-table-header">Status</th>
              <th class="apple-table-header">Anzahl Coins</th>
              <th class="apple-table-header">Coins angewendet am</th>
              <th class="apple-table-header">Angewendet von</th>
              <th class="apple-table-header">Aktionen</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders$ | async" class="apple-table-row" [ngClass]="{
              'status-approved': order.status?.name === 'Genehmigt',
              'status-pending': order.status?.name === 'Ausstehend',
              'status-declined': order.status?.name === 'Abgelehnt'
            }">
              <td class="apple-table-cell">{{ order.reflexOrderNo }}</td>
              <td class="apple-table-cell">
                <span class="status-badge" [ngClass]="{
                'badge-approved': order.status?.name === 'Genehmigt',
                'badge-pending': order.status?.name === 'Ausstehend',
                'badge-declined': order.status?.name === 'Abgelehnt'
              }">
                  {{ order.status?.name }}
                </span>
              </td>
              <td class="apple-table-cell">{{ order.coinsUsed }}</td>
              <td class="apple-table-cell">
                {{ order.createdDate | date : "dd.MM.yyyy" : "UTC" }}
              </td>
              <td class="apple-table-cell">
                {{ order.customer?.userDetails?.firstName }}
                {{ order.customer?.userDetails?.lastName }}
              </td>
              <td class="apple-table-cell actions-cell">
                <ng-container *ngIf="order.status?.name === 'Ausstehend'">
                  <button class="apple-button apple-button-small apple-button-success" matTooltip="Genehmigen"
                    (click)="changeOrderStatus(order.id, 'approve')">
                    <mat-icon>check_circle</mat-icon>
                  </button>
                  <button class="apple-button apple-button-small apple-button-error" matTooltip="Ablehnen"
                    (click)="changeOrderStatus(order.id, 'decline')">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </ng-container>
              </td>
            </tr>
          </tbody>
        </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>